
import React from "react";
import * as joto from "../../api/joto";
import * as jotoui from "../../joto-ui-api";
import {ProjectDetailBasic} from "./ProjectDetailBasic";
import * as log from 'loglevel';
import * as jotoTypes from "../../api/joto-types";
import {connect} from "react-redux";
import {Form} from "react-final-form";
import {FormGroupInput, FormGroupTextarea} from "../FormGroup";
import {sleep, validateLong, validateShort} from "../JotoUIUtils";
import * as env from "../../env";

const logger = log.getLogger('SelectedProjectModalView.tsx');
logger.setLevel(env.logLevel);

interface SelectedProjectViewState {
    selectedProject: jotoTypes.ProjectPath | null
}

interface SelectedProjectViewProps extends SelectedProjectViewState {
    joto: joto.Joto,
    jotoui: jotoui.JotoUIApi,
    modal: boolean,
    likeElement: boolean,
    closeElement: boolean,
    permLinkPage?: boolean,
    propertySelectedProject?: jotoTypes.Project
}

interface SelectedProjectViewLocalState {
    userNickName: string
}

// type StyleProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

class SelectedProjectView_ extends React.Component<SelectedProjectViewProps, SelectedProjectViewLocalState> {

    constructor(props: SelectedProjectViewProps) {
        super(props);

        this.state = {userNickName: ''};

        this.getProject = this.getProject.bind(this);
        this.fetchProjectOwnerNickName = this.fetchProjectOwnerNickName.bind(this);
        this.sendEMail = this.sendEMail.bind(this);
    }

    state : SelectedProjectViewLocalState;

    async componentDidMount() {
        // ReactTooltip.rebuild();
        return this.fetchProjectOwnerNickName();
    }

    async componentDidUpdate(prevProps: Readonly<SelectedProjectViewProps>, prevState: Readonly<{}>, snapshot?: any): Promise<void> {
        return this.fetchProjectOwnerNickName();
    }

    async fetchProjectOwnerNickName() {
        logger.debug('SelectedProjectView_.fetchProjectOwnerNickName()');

        const project = this.getProject();
        if(!project) {
            logger.debug('ProjectDetailBasic_.componentDidUpdate: this.getProject() did not deliver a valid result, most likely, because the project detail page was closed and no valid project is selected : ' + JSON.stringify(project) + ', ' + this.props.selectedProject);
            return;
        }

        const publicProfile = await this.props.joto.getPublicProfile(project.uid);
        if(!publicProfile) {
            logger.warn(`ProjectDetailBasic_.componentDidUpdate: prevProps.joto.getPublicProfile(project.uid = ${project.uid}) did not deliver valid results : ` + JSON.stringify(publicProfile));
            return;
        }
        if(this.state.userNickName !== publicProfile.nick) {
            logger.debug(`ProjectDetailBasic_.componentDidUpdate: prevProps.joto.getPublicProfile(project.uid = ${project.uid}) setting state : ` + JSON.stringify({userNickName: publicProfile.nick}));
            this.setState({userNickName: publicProfile.nick});
        } else {
            logger.debug(`ProjectDetailBasic_.componentDidUpdate: prevProps.joto.getPublicProfile(project.uid = ${project.uid}) skip setting state, because value did not change: ` + JSON.stringify({userNickName: publicProfile.nick}));
        }
    }

    getProject() : jotoTypes.Project | null {
        if(this.props.propertySelectedProject) {
            return this.props.propertySelectedProject;
        } else {
            if(this.props.selectedProject == null)
                return null;

            // noinspection UnnecessaryLocalVariableJS
            const project = this.props.jotoui.projectFromPath(this.props.selectedProject);
            return project;
        }
    }

    async sendEMail({subject, text} : {subject: string, text: string}) {
        // check if logged in!
        logger.debug(JSON.stringify({subject, text}));
        if(!this.props.joto.userData) {
            logger.warn(`ProjectDetailBasic_.sendEMail: user is not logged in -> not sending e-mail.`);
            this.props.jotoui.failedMessage('Kontakt', 'Du bist nicht eingelogged. Deshalb kannst Du das Kontaktformular nicht aufrufen.');
            if((window as any).$)
                (window as any).$('#project-detail-modal-contact-form').modal('hide');
            return;
        }
        const project = this.getProject();
        if(!project) {
            logger.error('ProjectDetailBasic_.sendEMail: this.getProject() did not deliver a valid result, therefore cannot send e-mail: ' + JSON.stringify(project) + ', ' + JSON.stringify(this.props.selectedProject));
            this.props.jotoui.failedMessage('Kontakt', 'Die Projektdetails konnten nicht gefunden werden. Dieser Fehler sollte nicht auftreten. Bitte wende dich an den Support und gib folgende Infos weiter:' +  JSON.stringify(project) + ', ' + JSON.stringify(this.props.selectedProject));
            if((window as any).$)
                (window as any).$('#project-detail-modal-contact-form').modal('hide');
            return;
        }

        const frm = this.props.joto.userData.email;
        const toUid = project.uid;
        logger.debug(`ProjectDetailBasic_.sendEMail: sending data: ${JSON.stringify({frm, toUid, subject, text},null,2)}`);

        const fakeEmail = !(process.env.NODE_ENV === 'production');
        if(fakeEmail) {
            await sleep(3000);
            this.props.jotoui.successMessage('Kontakt', 'Would send e-mail: ' + JSON.stringify({frm, toUid, subject, text},null,2), 10000);
        }

        try {
            if(!fakeEmail)
                await this.props.joto.sendEmail(frm, toUid, subject, text);
            logger.debug('Sending e-mail finished: ' + JSON.stringify({frm, toUid, subject, text},null,2));
            this.props.jotoui.successMessage(`Kontakt`, 'Die Nachricht wurde abgeschickt.');
            if((window as any).$)
                (window as any).$('#project-detail-modal-contact-form').modal('hide');
        } catch(e) {
            this.props.jotoui.failedMessage(`Kontakt`, `Beim senden der Nachricht ist ein Fehler aufgetreten: ${JSON.stringify(e, null, 2)}.`);
            logger.error('ProjectDetailBasic : Error : ' + JSON.stringify(e));
        }
    }

    render() {
        const project = this.getProject();
        if(!project) {
            logger.warn('Should never happen, that not a single project is available!');
            return null;
        }

        // width-max: 1140px
        let mainView = null;
        if(this.props.modal) {
            mainView = (
                <div id="main-selected-project-modal-view" className="modal show" style={{paddingLeft: 0}} tabIndex={-1} role="dialog">
                    <div className="modal-dialog" role="document" style={{maxWidth: 1000}}>
                        <div className="modal-content" style={{paddingLeft: 15, paddingRight: 15}}>
                            <div className="modal-header">
                                <h5 className="modal-title">{project.name}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span
                                    aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body container">
                                <ProjectDetailBasic joto={this.props.joto} jotoui={this.props.jotoui} likeElement={this.props.likeElement} closeElement={this.props.closeElement} userNickName={this.state.userNickName} permLinkPage={this.props.permLinkPage} propertySelectedProject={project}/>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Schließen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            mainView = <ProjectDetailBasic joto={this.props.joto} jotoui={this.props.jotoui} likeElement={this.props.likeElement} closeElement={this.props.closeElement} userNickName={this.state.userNickName} permLinkPage={this.props.permLinkPage} propertySelectedProject={project}/>;
        }

        return (
            <>
                {mainView}
                <div id="project-detail-modal-contact-form" className="modal" tabIndex={-1} role="dialog" aria-labelledby="projectDetailModalContactForm" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <Form onSubmit={this.sendEMail} initialValues={{subject: '', text: ''}}>
                                {({handleSubmit, submitting}) => {

                                    let alert_class = 'alert-success d-none'; // 'alert-warning', 'alert-danger';
                                    let alert_text = '&nbsp;';
                                    if(submitting) {
                                        alert_class = 'alert-warning';
                                        alert_text = '... wird gesendet ...'
                                    } else {
                                        alert_class = 'alert-success d-none'; // 'alert-warning', 'alert-danger';
                                        alert_text = '&nbsp;'
                                    }

                                    return <form onSubmit={handleSubmit}>
                                        <div className="modal-header">
                                            <h5 className="modal-title">Kontaktiere {this.state.userNickName}</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        </div>
                                        <div className="modal-body">
                                            <FormGroupInput prefix="project-detail-contact-form"
                                                            valuePropertyKey="subject" label="Betreff"
                                                            placeholder="Betreff" validate={validateShort}/>
                                            <FormGroupTextarea prefix="project-detail-contact-form"
                                                               valuePropertyKey="text" label="E-Mail Inhalt"
                                                               placeholder="Lieber Projektinitiator, ..."
                                                               validate={validateLong} />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary"
                                                    data-dismiss="modal">Schließen
                                            </button>
                                            <button type='submit' className="btn btn-dark">Abschicken</button>
                                        </div>
                                        <div className={"alert mt-2 " + alert_class} role="alert">
                                            {alert_text}
                                        </div>
                                    </form>
                                }}
                            </Form>
                        </div>
                    </div>
                </div>
            </>
        );
    }

}

const SelectedProjectModalView_mapStateToComponentState = (state : jotoui.JotoUIState) : SelectedProjectViewState => ({
    selectedProject: state.ui.selectedProjectView.selectedProject
});

export const SelectedProjectView = connect(SelectedProjectModalView_mapStateToComponentState)(SelectedProjectView_);
